import { FC, PropsWithChildren, ReactNode } from 'react';

import clsx from 'clsx';

import css from './ProfileCard.module.css';

import { Card } from 'v2/components/card/Card';
import { WithClassName } from 'v2/types';

interface ProfileCardProps extends WithClassName {
  title: string;
  icon?: ReactNode;
}

export const ProfileCard: FC<PropsWithChildren<ProfileCardProps>> = ({ className, title, icon, children }) => (
  <Card className={clsx(css.profileCard, className)}>
    <div className={css.profileCardHeader}>
      {icon}

      <h3 className={css.profileCardTitle}>{title}</h3>
    </div>

    {children}
  </Card>
);
